import axios from 'axios';
import { helperGetApiHeaders, helperGetApiRoute, axiosErrorHandler } from 'helpers/ApiHelper';

export const FETCH_PCS = 'FETCH_PCS';

export function fetchPCS(accessToken) {
  const pageType = 'pcs';
  const url = `${helperGetApiRoute(pageType)}?timestamp=${new Date().getTime()}`;
  const headers = helperGetApiHeaders({ pathKey: pageType, accessToken });
  const request = axios.get(url, headers).catch(axiosErrorHandler);

  return {
    type: FETCH_PCS,
    payload: request,
  };
}

export function setPCS(accessToken, data) {
  const pageType = 'pcs';
  const url = helperGetApiRoute(pageType);
  const headers = helperGetApiHeaders({ pathKey: pageType, accessToken });
  axios.put(url, data, headers).catch(axiosErrorHandler);
}
